// extracted by mini-css-extract-plugin
module.exports = {"criteriaWrapper":"password-validation_criteriaWrapper__b8rC_","labelText":"password-validation_labelText__Ndb9t"};